import { Skeleton } from '@/bc/skeleton/image-skeleton'
import { cn } from '@/lib/utils'
import { forwardRef, useMemo, useState } from 'react'
const DEFAULT_IMG = 'https://cdn.zhiyitech.cn/material/5d7a917582973da229031dff003fb573'
const _Image = (
  { src, w = 0, className, style, ...rest }: React.ComponentProps<'img'> & { w?: number },
  ref: React.ForwardedRef<HTMLImageElement>,
) => {
  const [loaded, setLoaded] = useState(false)
  const [error, setError] = useState(false)
  const dist = useMemo(() => {
    if (src?.includes('zhiyi-image.oss-cn-hangzhou.aliyuncs.com') || src?.includes('zhiyi-image-cdn.zhiyitech.cn')) {
      const cdnSrc = src.replace('zhiyi-image.oss-cn-hangzhou.aliyuncs.com', 'img-cdn.zhiyitech.cn')
      if (w > 0) {
        return cdnSrc + '?x-oss-process=image/resize,w_' + Math.floor(devicePixelRatio * w)
      }
      return cdnSrc
    }
    if (src?.includes('zhiyi-web.oss-cn-hangzhou.aliyuncs.com')) {
      const cdnSrc = src.replace('zhiyi-web.oss-cn-hangzhou.aliyuncs.com', 'web-cdn.zhiyitech.cn')
      if (w > 0) {
        return cdnSrc + '?x-oss-process=image/resize,w_' + Math.floor(devicePixelRatio * w)
      }
      return cdnSrc
    }
    return src || DEFAULT_IMG
  }, [src, w])
  return (
    <div className={cn(className, 'relative overflow-hidden')} style={style}>
      {!loaded && <Skeleton className="absolute inset-0 w-full h-full" />}
      <img
        className={cn(className, 'border-0 shadow-none m-0 p-0 w-full h-full rounded-none min-w-full')}
        ref={ref}
        src={error ? DEFAULT_IMG : dist}
        loading="lazy"
        referrerPolicy="no-referrer"
        style={{ opacity: loaded ? 1 : 0, transition: 'opacity 0.3s' }}
        onLoad={() => setLoaded(true)}
        onError={() => {
          setLoaded(true)
          setError(true)
        }}
        {...rest}
      />
    </div>
  )
}
export const Image = forwardRef(_Image)
